import { AnalyticsContextValue } from "@swiggy-private/analytics";

interface PaymentCartEventParams {
    event: AnalyticsContextValue["impressionEvent"] | AnalyticsContextValue["clickEvent"];
    category: string;
    action: string;
    label: string;
    context: string;
}

export const paymentCartImpressionEvent = ({
    event,
    category,
    action,
    label,
    context,
}: PaymentCartEventParams): void => {
    event({
        category,
        action,
        label,
        context,
    });
};

export const dinecashPoolingWidgetImpressionEvent = ({
    event,
    category,
    action,
    label,
    context,
}: PaymentCartEventParams): void => {
    event({
        category,
        action,
        context,
        label,
    });
};

export const dinecashPoolingWidgetClickEvent = ({
    event,
    category,
    action,
    label,
    context,
}: PaymentCartEventParams): void => {
    event({
        category,
        action,
        label,
        context,
    });
};

export const paymentCartClickEvent = ({ event, category, action, label, context }: PaymentCartEventParams): void => {
    event({
        category,
        action,
        label,
        context,
    });
};
